import { render, staticRenderFns } from "./UsuarioExterno.vue?vue&type=template&id=ba139e2a"
import script from "./UsuarioExterno.vue?vue&type=script&lang=js"
export * from "./UsuarioExterno.vue?vue&type=script&lang=js"
import style0 from "./UsuarioExterno.vue?vue&type=style&index=0&id=ba139e2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports